import { Container, Typography } from "@mui/material";

import { Section } from "..";
import Capabilities from "./Capabilities";
import Versus from "./Versus";
import CTA from "./CTA";

export default function Agent() {
  // const { data = [] } = useSWR("/api/model", url =>
  //   fetch(url).then(res => res.json())
  // );

  return (
    <>
      <Section
        display="flex"
        flexDirection="column"
        justifyContent="space-around"
        minHeight="calc(100vh - 80px - 280px)"
      >
        <Container
          maxWidth="expanded"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Typography
            textAlign="center"
            color="dark.surface.on.color"
            sx={{
              textWrap: "balance",
              textAlign: "center",
              width: "100%",
              typography: { compact: "displaySm", expanded: "displayLg" }
            }}
          >
            Bytez is grounded in AI research and outperforms GPT-4
          </Typography>
        </Container>
      </Section>
      <Versus />
      <Capabilities />
      <CTA />
    </>
  );
}
